import { useEffect, useState } from 'react';
/**
 * Subscribe to a CSS media query and return whether it currently matches.
 * Updates on viewport / capability changes.
 */
export function useMediaQuery(query) {
    const [matches, setMatches] = useState(() => typeof window === 'undefined' ? false : window.matchMedia(query).matches);
    useEffect(() => {
        const mediaQuery = window.matchMedia(query);
        const handleChange = (event) => setMatches(event.matches);
        setMatches(mediaQuery.matches);
        mediaQuery.addEventListener('change', handleChange);
        return () => mediaQuery.removeEventListener('change', handleChange);
    }, [query]);
    return matches;
}
